import { Link } from 'react-router-dom'

const YEAR = new Date().getFullYear()

function XIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-7 w-7 fill-current" aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  )
}
function FacebookIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-7 w-7 fill-current" aria-hidden="true">
      <path d="M13.5 22v-8.2h2.8l.4-3.3h-3.2V8.4c0-.9.3-1.6 1.6-1.6h1.7V3.9c-.3 0-1.3-.1-2.5-.1-2.5 0-4.2 1.5-4.2 4.3v2.4H7.3v3.3h2.8V22h3.4z" />
    </svg>
  )
}
function InstagramIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-7 w-7 fill-none stroke-current" strokeWidth="2" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="1" className="fill-current" />
    </svg>
  )
}

/** Rainbow-gradient footer with social links, copyright, and two link columns. */
export default function Footer() {
  return (
    <footer
      className="bg-cover-section section-tight text-white"
      style={{ backgroundImage: 'url(/images/cm-footer-bg.webp)' }}
    >
      <div className="mx-auto grid max-w-[1800px] grid-cols-1 items-start gap-8 md:grid-cols-12 md:gap-6">
        <div className="flex flex-col items-start gap-4 md:col-span-4">
          <Link to="/" className="no-underline" aria-label="ColorMark home">
            <img src="/images/cm-logo-white-1200.png" alt="ColorMark" width={200} height={50} className="h-auto w-[200px]" />
          </Link>
          <p className="text-sm leading-7">
            Copyright © {YEAR} ColorMark™
            <br />
            All Rights Reserved
          </p>
        </div>

        <div className="flex items-center gap-6 md:col-span-4 md:justify-center md:pt-2">
          <a href="https://x.com/colormarkorg" aria-label="ColorMark on X" className="no-underline">
            <XIcon />
          </a>
          <a href="https://www.facebook.com/ColorMarkOrg" aria-label="ColorMark on Facebook" className="no-underline">
            <FacebookIcon />
          </a>
          <a href="https://www.instagram.com/colormarkorg/" aria-label="ColorMark on Instagram" className="no-underline">
            <InstagramIcon />
          </a>
        </div>

        <nav className="flex flex-col gap-1 md:col-span-2" aria-label="Footer">
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/registry">Registry</Link>
        </nav>
        <nav className="flex flex-col gap-1 md:col-span-2" aria-label="Legal">
          <Link to="/faq">FAQ</Link>
          <Link to="/api-docs">API</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-of-service">Terms of Service</Link>
        </nav>
      </div>
    </footer>
  )
}
